export const Pen = () => {
  return (
    <svg viewBox="0 0 24 24" height="24" width="24" fill="none">
      <path
        d="m19.011 10.302-5-5 2.687-2.688a2.095 2.095 0 0 1 2.962 0l2.04 2.04a2.095 2.095 0 0 1 0 2.961l-2.689 2.687Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m19.011 10.302-5-5-6.46 2.71a2.358 2.358 0 0 0-1.62 1.62l-2.908 10.93a.59.59 0 0 0 .728.729l10.93-2.904a2.36 2.36 0 0 0 1.62-1.625l2.71-6.46ZM3.173 21.14l7.943-7.944"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
